import { PowerBiForm } from "@app/components/forms/admin/power-bi-form.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/admin/power-bi/settings")({
    component: RouteComponent,
});

function RouteComponent() {
    return <PowerBiForm />;
}
